import { useEffect } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm, FormInput, TextOutput, ThemeType,
} from '../../../../..';

export function ModelOutput({
  id,
  field,
  label,
  labelStyles = '',
  valueOverride,
  errorOverride = '',
  onVisibleChange,
  containerCss,
}: {
  id: string,
  field: string,
  label: string,
  labelStyles?: string,
  valueOverride?: string,
  errorOverride?: string,
  onVisibleChange?: (visible: boolean) => void,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
}) {
  const { visible, value } = useModelForm(field, valueOverride, errorOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  return (
    <FormInput visible={visible} css={containerCss}>
      <TextOutput
        id={id}
        label={label}
        labelStyles={labelStyles}
        value={value}
      />
    </FormInput>
  );
}
